module.exports = __webpack_public_path__ + "img/trends.34b69508.png";